'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  COMPANY: 'company',
  CUSTOMER: 'customer'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.327/js/constants/TitleTypes.js
// module id = 847
// module chunks = 2 3